/* eslint-disable @ok/oklint/no-hardcode-variable */
/* eslint-disable @ok/oklint/no-space */
export default {
  index_assets_total: 'Total assets',
  index_assets_top_crypto: 'Top Crypto',
  index_assets_top_fluctuation: '24H Fluctuation Rate',
  index_medias_title: 'News',
  tutor_page_title: 'For Android devices',
  tutor_page_step1:
    'Open the OkJ App, select Trade and then click the K-line chart button at the top-right corner to enter the K-line chart page, or you can select Buy/Sell > K-line chart. Click the Monitor icon on the bottom.',
  tutor_page_step2:
    'Turn on Real-time Monitor, and grant the permission to "Display on other apps". Click Add Crypto > select your Crypto > click Save to complete the process.',
  see_more: 'View more',
  rss_page_title: 'Market news',
  btc_index_top_subtitle:
    'The OKJ BTC Index discloses on a daily basis the buy/sell price of 1 BTC at OKJ.',
  btc_index_tip1:
    'The listed price does not guarantee the final price between OKJ or other paricipating traders. Please check our latest trading information upon trading. ',
  btc_index_tip2:
    'Information may not be up-to-date due to latencies within the system. The price is calculated automatically by the system, but may differ from the actual price due to factors like system maintenance.',
  btc_index_tip3:
    'Information posted here is latest as of the time of creation, and should be only used as a point of reference.',
  btc_index_download_csv_file: 'Download CSV',
  btc_index_download_csv_title: 'Historical Data',
  btc_index_crypto_currency_name: 'Cryptocurrency',
  btc_index_crypto_currency_purchase: 'Buying Rate',
  btc_index_crypto_currency_sell: 'Selling Rate',
  btc_index_crypto_currency_market_price: 'Middle Rate',
  btc_index_crypto_currency_btc: 'Bitcoin',
  btc_index_crypto_currency_date: 'Date',
  btc_index_crypto_currency_unit: 'Yen',
  btc_index_crypto_currency_today: 'Today',
  btc_index_crypto_currency_yesterday: 'Yesterday',
  btc_index_year_split_symbol: '/',
  btc_index_month_split_symbol: '/',
  btc_index_day_split_symbol: '',
  today_change_date: '24時間',
  seven_days_date: '7日間',
  thirty_days_date: '30日間',
  this_year_date: '1年',
  view_all: 'もっと見る',
  currency_folder_close: '閉じる',
  currency_info_data_title:
    '{symbolFullName}（{currencyName}）のリアルタイム情報',
  currency_office_site: '公式サイト',
  currency_white_paper: 'ホワイトペーパー',
  currency_office_github: 'Github',
  currency_block_explorer: 'エクスプローラー',
  currency_block_twitter: 'Twitter',
  currency_block_facebook: 'facebook',
  currency_price_performance: '価格情報',
  currency_time_range: '対象期間',
  currency_price_amount: '変動額',
  currency_price_rate: '変動率',
  currency_market_info: '{currencyFullName}（{currencyName}）の基本情報',
  currency_market_value: '時価総額',
  currency_history_highest_price: '史上最高値',
  currency_history_lowest_price: '史上最安値',
  currency_first_release: '発行開始',
  currency_history_max_offer: '最大供給量',
  currency_circulation_amount: '循環供給量（流通量）',
  currency_circulation_rate: '流通率(％)',
  currency_belong_link: 'ネットワーク',
  currency_admit_ways: '承認方式',
  currency_base_info_title: '{symbolFullName}（{symbol}）とは',
  currency_buy_calculator_button: '購入',
  currency_buy_calculator_pay: '金額',
  currency_buy_calculator_get: '数量',
  currency_buy_calculator_title: '{symbol}購入シミュレーション',
  currency_trade_title: '取引所',
  currency_staking_title: 'ステーキング',
  currency_sns_title: '公式SNSアカウント',
  currency_media_title: 'メディア',
  currency_go_trade: '取引する',
  currency_go_apply: '申請する',
  currency_staking_content1: '預けて増やす報酬',
  currency_staking_content2: '毎日受け取る',
  currency_to_concern: 'フォロー',
  resource_title_about: '{currencyFullName}（{symbol}）関連サイト',
  faq_content_title: '{currencyFullName}（{symbol}）FAQ',
  currency_base_info_increase_tips1:
    '現在の{symbol}価格は{price}円。{symbol}価格は過去24時間で{percentage}％上昇。OKJは{symbol}価格をリアルタイムで更新します。',
  currency_base_info_decrease_tips1:
    '現在の{symbol}価格は{price}円。{symbol}価格は過去24時間で{percentage}％下落しています。OKJは{symbol}価格をリアルタイムで更新します。',
  currency_base_info_tips2:
    '{symbol}は暗号資産の時価総額ランキングで{rankNumber}位です。現在の{symbol}時価総額は{volumeCap}円です。',
  currency_base_info_tips3:
    '{symbol}の流通量は{circulationAmount}{symbol}で、最大供給量は{distributionAmount}{symbol}です。',
  currency_circulation_rate_tip: '流通量÷最大供給量',
  currency_circulation_amount_tip: '現在市場に流通している数量',
  currency_history_max_offer_tip: '市場に流通できる最大数量',
  currency_breadcrumbs_spot_title: 'マーケット',
  currency_breadcrumbs_sale_title: '販売所',
  currency_breadcrumbs_trade_title: '取引所',
  currency_breadcrumbs_title: '{currencyFullName}（{symbol}）',
  currency_year_split_symbol: '年',
  currency_month_split_symbol: '月',
  currency_day_split_symbol: '日',
  currency_price: '価格',
  web_homepage_recurringbuy_title: 'Recurring buy',
  web_homepage_staking_title: 'Staking',
  web_homepage_staking_desc:
    'You can earn staking rewards every day just by holding the selected cryptocurrency.',
  web_homepage_staking_rate: 'Maximum annual return',
  web_homepage_staking_soon: 'Coming soon',
  view_home_register_right_tip1: '24/7 service',
  view_home_register_right_tip2: 'Global standard pricing & spread',
  view_home_register_right_tip3: 'High liquidity & frequency',
  view_home_reason_title: 'OKJ Why Choose Us',
  view_home_reason_security_tip1: 'Solid Security System',
  view_home_reason_security_tip2: 'and All-day Support',
  view_home_reason_security_tip3: '100% cold wallet management',
  view_home_reason_security_tip4: 'Two-Factor Authentication',
  view_home_reason_security_tip5: 'Prompt customer support',
  view_home_reason_security_title1: 'Security',
  view_home_reason_security_title2: 'Settings',
  view_home_reason_balance_tip1: 'Fast and Safe',
  view_home_reason_balance_tip2: 'Deposit/Withdrawal',
  view_home_reason_balance_tip3: 'Comprehensive multi-chain support',
  view_home_reason_balance_tip4: 'Instant response 24 hours a day',
  view_home_reason_balance_tip5: 'Deposit and withdrawal of JPY and cryptos',
  view_home_reason_balance_title1: 'Assets',
  view_home_reason_balance_title2: '',
  view_home_reason_trade_tip1: 'High Liquidity',
  view_home_reason_trade_tip2: 'Low Slippage',
  view_home_reason_trade_tip3: 'Global standard trading environment',
  view_home_reason_trade_tip4: 'Abundant altcoin matching support',
  view_home_reason_trade_tip5: 'Highly convenient trading tool',
  view_home_reason_trade_title1: 'Trade',
  view_home_reason_trade_title2: '',
  view_home_reason_api_tip1: 'Powerful and Stable',
  view_home_reason_api_tip2: 'Transaction API',
  view_home_reason_api_tip3: 'Support Websocket and REST API',
  view_home_reason_api_tip4: 'Higher API request limits',
  view_home_reason_api_tip5: 'Provide SDK',
  view_home_reason_api_title1: 'API',
  view_home_reason_api_title2: '',
  view_home_reason_inquiryForm_tip1: 'Comprehensive',
  view_home_reason_inquiryForm_tip2: 'Corporate Services',
  view_home_reason_inquiryForm_tip3:
    'Compliant with the [月末時価評価税適用外] tax law',
  view_home_reason_inquiryForm_tip4: 'Support large transactions',
  view_home_reason_inquiryForm_tip5: 'Available to overseas corporations',
  view_home_reason_inquiryForm_title1: 'Contact Us',
  view_home_reason_inquiryForm_title2: '',
  view_home_flow_title_tips2: 'Start trading in just 15 minutes!',
  view_home_flow_step1_title: 'Sign up with email',
  view_home_flow_step2_title1: 'Enter your personal information',
  view_home_flow_step2_title2: 'Verify with eKYC',
  view_home_flow_step3_title: 'Start trading!',
  view_home_sale_card_title: 'Start trading with ease',
  view_home_sale_card_btn: 'Trade now',
  view_index_news_title: 'Announcement',
  view_index_market_news_title: 'Market news',
  view_index_news_btn: 'View more',
  view_home_faq_title: 'FAQ',
  view_home_faq_guidelines_page: 'the guidelines page',
  view_home_faq_click_here: 'Click here',
  view_home_faq_more_link: 'https://support.okj.com/hc/en-us',
  view_home_faq_first_title: 'How long does it take to open an account?',
  view_home_faq_first_info1:
    'Account registration, including identity verification, can be completed in as little as 5 minutes.',
  view_home_faq_first_info2: '',
  view_home_faq_first_info3: ' to learn about the required procedures.',
  view_home_faq_first_info4:
    '※Account registration is subject to review which may take some time to complete depending on the situation.',
  view_home_faq_second_title: 'Can a legal entity open an account?',
  view_home_faq_second_info1:
    'Corporate customers can also open an account and use our service.',
  view_home_faq_second_info2: '',
  view_home_faq_second_info3:
    ' to view more about the account opening process.',
  view_home_faq_third_title: 'How long does it take to deposit or withdraw?',
  view_home_faq_third_info1:
    'OKJ supports the deposit and withdrawal of JPY and crypto assets 24 hours a day, 365 days a year.',
  view_home_faq_third_info2:
    'You can use the service without missing any trading opportunity.',
  view_home_faq_fourth_title: 'What cryptos does OKJ support?',
  view_home_faq_fourth_info1:
    'In addition to BTC, ETH and XRP, we also offer a wide range of mainsteam cryptos which are available on Trade and Buy/Sell.',
  view_home_faq_fourth_info2: '',
  view_home_faq_fourth_info3: 'to view trading pairs on Trade.',
  view_home_faq_fourth_info4: 'to view cryptos on Buy/Sell.',
  view_home_faq_fifth_title:
    'What are the differences between Trade and Buy/Sell?',
  view_home_faq_fifth_info1:
    'Under our Trade session, exchange matches the orders of buyers and sellers. It is also known as book-entry trading because the orders of the participants form an order book. You can choose how to order and trade at a reduced trading cost.',
  view_home_faq_fifth_info2:
    'As for Buy/Sell, it is an over-the-counter (OTC) trading where customers trade with crypto exchange service providers immediately after placing an order. You can buy and sell in a few steps and it is easy to use for beginners.',
  view_home_faq_sixth_title: 'What is Staking service?',
  view_home_faq_sixth_info1:
    'Staking is a mechanism that allows you to hold crypto assets and contribute to the maintenance and approval of the blockchain. You can earn staking rewards for your contributions.',
  view_home_faq_sixth_info2:
    "With OKJ's Staking service, you can earn rewards every day, which you can claim at any time.",
  view_home_faq_sixth_info3: 'Please visit ',
  view_home_faq_sixth_info4: 'for further details.',
  view_home_faq_seventh_title: ' What are Flash Deals?',
  view_home_faq_seventh_info1:
    'By participating in Flash Deals, you can earn great rewards during a limited period of time. For each transaction, the participant only needs to determine the target cypto, APY, execution cycle, and asset quantity. Flash Deals are held from time to time.',
  view_home_faq_seventh_info2: 'Please visit ',
  view_home_faq_seventh_info3: 'for further details.',
  web_banner_register_button: 'Try OKJ',
  web_homepage_download: 'Download App',
  web_homepage_product_buysell_dec:
    'You can easily buy and sell crypto. Our platform is easy to use, and suitable for beginners. ',
  web_homepage_product_trade_dec:
    'You can set your own prices for trading crypto. All execution methods and advanced API connections are available.',
  web_homepage_bottom_download_title: 'Download the app now',
  web_homepage_recurringbuy_desc:
    'This service helps you automatically purchase fixed amounts of crypto at regular intervals.',
  web_homepage_download_subtitle: 'Easy trading anytime, anywhere',
  web_homepage_download_register: 'Sign Up',
  web_homepage_sale_title: 'Buy/Sell',
  web_homepage_trade_title: 'Trade',
  web_homepage_trade_volume: '24h Vol',
  web_homepage_trade_date: 'Time',
  // Recruit pages
  recruit_top_hero_desc:
    'FSA-registered. Building a global trading experience in Japan.',
  recruit_top_openings_title: 'Job Openings',
  recruit_filter_all: 'All',
  recruit_top_more: 'View More',
  recruit_top_reasons_title: 'Why Join Us',
  recruit_reason_flat_title: 'Flat Organization',
  recruit_reason_flat_desc: 'Ideas over hierarchy\nFast decision-making',
  recruit_reason_global_title: 'Global × Local',
  recruit_reason_global_desc:
    'Global standards, tailored to the Japanese market',
  recruit_reason_learn_title: 'Learn & Grow',
  recruit_reason_learn_desc: 'Stay at the forefront of Web3',
  recruit_reason_speed_title: 'Speed & Execution',
  recruit_reason_speed_desc: 'High collaboration\nReliable shipping',
  recruit_apply: 'Apply',
  recruit_job_openings: 'Job Openings',
  recruit_job_description: 'Job Description',
  recruit_job_relevant_title: 'Relevant Jobs',
  recruit_job_more: 'More',
  recruit_submit_apply: 'Apply',
  recruit_submit_to_job_desc: 'Job Description',
  recruit_form_family_name: 'Family Name',
  recruit_form_first_name: 'First Name',
  recruit_form_birthday: 'Birthday',
  recruit_form_email: 'E-mail',
  recruit_form_location: 'Location (Country/City, e.g., Tokyo, Japan)',
  recruit_form_resume: 'Resume',
  recruit_form_cv: 'Curriculum Vitae/ Portfolio',
  recruit_form_salary: 'Expected Annual Salary',
  recruit_form_jpy: 'JPY',
  recruit_form_desired: 'Desired Conditions',
  recruit_form_privacy: 'Handling of Personal Information in Recruitment',
  recruit_form_submit: 'Submit',
  recruit_form_email_invalid: 'Please enter a valid email address.',
  recruit_form_digits_only: 'Please enter digits only.',
  recruit_top_jp_only_notice:
    '*Job descriptions are currently available in Japanese only',
  recruit_top_filter_aria: 'Job type filter',
  recruit_back: 'Back',
  recruit_form_gender: 'Gender',
  recruit_form_gender_male: 'Male',
  recruit_form_gender_female: 'Female',
  recruit_form_family_name_required: 'Please enter your family name.',
  recruit_form_first_name_required: 'Please enter your first name.',
  recruit_form_birthday_required: 'Please enter your birthday.',
  recruit_form_email_required: 'Please enter your email address.',
  recruit_form_location_required: 'Please enter your location.',
  recruit_upload_attach: 'Please attach a file',
  recruit_upload_attach_hint:
    '(.pdf / .doc / .docx / .xls / .xlsx / .png / .jpg / .jpeg. Max file size: 5MB)',
  recruit_upload_resume_required: 'Please upload your resume.',
  recruit_upload_format_invalid: 'Unsupported file format.',
  recruit_upload_size_invalid: 'The maximum file size allowed for upload is 5MB.',
  recruit_upload_total_size_invalid: 'The total file size must be within 15MB.',
  recruit_upload_contact_prefix: 'If you cannot upload it, please contact',
  recruit_upload_contact_suffix: '.',
  recruit_copied: 'Copied',
  recruit_submit_success: 'Submitted successfully',
  recruit_dialog_ok: 'OK',
  recruit_recaptcha_load_failed:
    'Failed to load security verification. Please reload the page.',
  recruit_recaptcha_failed: 'Security verification failed.',
  // ekyc refactor
  'kyc.mini.title': 'Simple Identity Verification',
  'kyc.mini.app.no.title': 'For users without the OKJ app on their smartphone',
  'kyc.mini.app.no.desc': 'Please download the app from the app store',
  'kyc.mini.app.have.title': 'For users who have already installed the OKJ app',
  'kyc.mini.app.have.desc': 'Users must have version 1.4.1 or later',
  'kyc.mini.toekyc.button': 'Proceed to eKYC',
  'kyc.mini.tips.title': 'Requirements & Notes',
  'kyc.mini.tips.desc.1':
    '＊Please submit documents that are valid and match your current residential address.',
  'kyc.mini.tips.desc.2':
    '＊The “Notification Card” cannot be used as a My Number Card.',
  'kyc.mini.tips.desc.3':
    '＊Foreign users must submit a Residence Card or a Special Permanent Resident Certificate.',

  // 用户迁移升级 -- start
  web_upgrade_button: 'Upgrade trading system',
  web_update_popup_title: '[OKJ Trading System Upgrade]',
  web_update_popup_tips_one: 'The OKJ trading system has been fully renewed.',
  web_update_popup_tips_two:
    'To upgrade to the new trading system, please click the “Update Now” button.',

  web_update_popup_tips_adv_title: 'Features of the New Trading System',
  web_update_popup_tips_adv_one: '1. Improved basic trading functions',
  web_update_popup_tips_adv_two:
    '2. Refreshed user interface for a more comfortable trading experience',
  web_update_popup_tips_adv_three:
    '3. Enhanced capacity to handle high traffic, ensuring greater system stability',

  web_update_popup_tips_notice_title: 'Notes',
  web_update_popup_tips_notice_one:
    '• Orders that have not been executed at the time of upgrade will be automatically canceled after the upgrade.',
  web_update_popup_tips_notice_two:
    '• The system will be automatically upgraded to the new trading system on : {date}',

  web_update_popup_button_later: 'Update Later',
  web_update_popup_button_now: 'Update Now',

  web_update_popup_upgrading_title: 'Upgrading',
  web_update_popup_upgrading_tips:
    'The system is being upgraded and will be completed in approximately {minute} minutes.',
  web_update_popup_upgrading_abnormal_tips:
    'If the upgrade is not completed for a long time, please click“Contact us”',
  web_update_popup_upgrading_button: 'Contact us',

  web_update_popup_upgrade_complete_title: 'Upgrade complete',
  web_update_popup_upgrade_complete_tips: 'Click below to start trading.',
  web_update_popup_upgrade_complete_button_trade: 'Trade now',
  // 用户迁移升级 -- end
};
